export default {
  name: 'convex-header',
  path: 'M 0 0 H 1 V 0.82 S 0.69 1 0.49 1 S 0 0.82 0 0.82 V 0 Z',
};
